const searchInJson = (obj, searchTerm) => {
  if (obj == null || searchTerm == null) {
    return false;
  }

  // Support multiple comma-separated terms (AND logic)
  const tokens = String(searchTerm)
    .split(',')
    .map((t) => t.trim())
    .filter((t) => t.length > 0);

  if (tokens.length === 0) {
    return false
  }

  const matchesSingleToken = (node, token) => {
    const term = String(token).toLowerCase();

    // Primitive: check the value itself
    if (typeof node !== "object" || node === null) {
      return String(node).toLowerCase().includes(term);
    }

    // For objects (including arrays):
    for (let key in node) {
      if (!Object.prototype.hasOwnProperty.call(node, key)) continue;

      // Check key name match (skip numeric-like keys to avoid noisy array-index matches)
      const isNumericKey = /^\d+$/.test(key);
      if (!isNumericKey && key.toLowerCase().includes(term)) {
        return true;
      }

      // Recurse into the value
      if (matchesSingleToken(node[key], term)) {
        return true;
      }
    }

    return false;
  };

  // AND across all tokens: every token must be found somewhere in the object
  for (const token of tokens) {
    if (!matchesSingleToken(obj, token)) {
      return false;
    }
  }
  return true;
};

const highlightText = (text, highlight) => {
  // Support multiple comma-separated terms for highlighting (OR in regex)
  const tokens = String(highlight)
    .split(',')
    .map((t) => t.trim())
    .filter((t) => t.length > 0);
  if (tokens.length === 0) return text;

  const escapeRegExp = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const pattern = tokens.map(escapeRegExp).join("|");
  const re = new RegExp(pattern, "gi");
  return text.replace(re, (match) => `<span class="highlight">${match}</span>`);
};

export { searchInJson, highlightText };
